import build from 'Cloud/Application/Build';
import user from 'Cloud/Application/User';
import whatsUp from 'Cloud/Application/WhatsUp';

export const initializeCloudAppCode = () => {
    user();
    build();
    whatsUp();
};
